import React from "react";
import MasonryHero from "../components/MasonryHero";
import SEO from "../components/SEO";
import { useLang } from "../i18n";

const Home = () => {
  const { t } = useLang();
  return (
    <main className="bg-white">
      <SEO title={null} description={null} path="/" />
      <MasonryHero />
    </main>
  );
};

export default Home;
